import { defineMessages } from 'react-intl';

export const creditLimitReachedUpgradeMessages = defineMessages({
  clinicianMaxUsageThresholdTitle: {
    defaultMessage: 'You used up {usagePercent}% of your usage',
    id: '3jNG27Cq6c',
    description:
      'Title for Clinician Max upgrade nudges at 50%, 75%, or 90% agent credit usage',
  },
  clinicianMaxHalfUsageDescription: {
    defaultMessage: 'Upgrade to Clinician Max to {multiplier}x your usage.',
    id: 'gZ53sv6pK8',
    description:
      'Description for the Clinician Max upgrade nudge at 50% agent credit usage. multiplier is 10 for FREE or trialing users, 5 for paid Clinician.',
  },
  clinicianMaxUpgradeCta: {
    defaultMessage: 'Get more usage',
    id: 'oKL9H4UDn3',
    description: 'CTA label for Clinician Max upgrade nudge banners',
  },
  clinicianMaxPlanName: {
    defaultMessage: 'Clinician Max',
    id: 'rxyvpjNLiq',
    description: 'Display name for the Clinician Max plan in upgrade nudge CTAs',
  },
  clinicianMaxExhaustedTitle: {
    defaultMessage: 'You used up your credit limit',
    id: 'AkPhpP27xI',
    description:
      'Title for the Clinician Max upgrade nudge when agent credits are exhausted',
  },
  clinicianMaxExhaustedDescription: {
    defaultMessage: 'Upgrade to Clinician Max to {multiplier}x your Heidi usage.',
    id: 's07rBSmBwI',
    description:
      'Description for the Clinician Max upgrade nudge when agent credits are exhausted. multiplier is 10 for FREE or trialing users, 5 for paid Clinician.',
  },
  practiceMaxUsageThresholdTitle: {
    defaultMessage: 'You used up {usagePercent}% of your usage',
    id: '1wZOqHQgs7',
    description:
      'Title for Practice Max upgrade nudges at 50%, 75%, or 90% agent credit usage',
  },
  practiceMaxHalfUsageDescription: {
    defaultMessage: 'Upgrade to Practice Max to {multiplier}x your usage.',
    id: 'QJ/r70KVWg',
    description:
      'Description for the Practice Max upgrade nudge at 50% agent credit usage. multiplier is 10 for FREE or trialing users, 5 otherwise.',
  },
  practiceMaxUpgradeCta: {
    defaultMessage: 'Upgrade',
    id: 'T29soeioFN',
    description: 'CTA label for Practice Max upgrade nudge banners',
  },
  practiceMaxPlanName: {
    defaultMessage: 'Practice Max',
    id: 'WVQV5tBYZ5',
    description: 'Display name for the Practice Max plan in upgrade nudge CTAs',
  },
  practiceMaxExhaustedTitle: {
    defaultMessage: 'You used up your credit limit',
    id: 'BClauHARVA',
    description:
      'Title for the Practice Max upgrade nudge when agent credits are exhausted',
  },
  practiceMaxExhaustedDescription: {
    defaultMessage: 'Upgrade to Practice Max to {multiplier}x your credit usage.',
    id: '/k7P0XhuHB',
    description:
      'Description for the Practice Max upgrade nudge when agent credits are exhausted. multiplier is 10 for FREE or trialing users, 5 otherwise.',
  },
  closeAriaLabel: {
    defaultMessage: 'Close',
    id: 'khWBOi8A/3',
    description: 'Accessible label for dismissing a plan upgrade nudge banner',
  },
});
